<app-sidebar-popout
  *appI18nScopeReady
  [title]="'timeseries_data' | i18n"
  icon="table_chart"
  [groups]="groups()"
  [activeItemId]="activeTableId()"
  [searchPlaceholder]="'search_timeseries' | i18n"
  [emptyMessage]="'no_timeseries_tables' | i18n"
  [showSettings]="canEdit()"
  [settingsLabel]="'manage_sections_entry' | i18n"
  [showAdd]="canAddTable()"
  [addLabel]="'add_table' | i18n"
  [sortToggleIcon]="sortMode() === 'group' ? 'sort_by_alpha' : 'workspaces'"
  [sortToggleTitle]="sortMode() === 'group' ? ('sort_alphabetical' | i18n) : ('sort_by_group' | i18n)"
  (popoutClose)="popoutClose.emit()"
  (itemSelect)="onItemSelect($event)"
  (itemAction)="onTableShare($event)"
  (settings)="openSectionManager()"
  (add)="addTable()"
  (sortToggle)="toggleSortMode()"
/>
